
// * ========================================================================
// * ages per day chart and table
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';
import storage from './../storage';

const agesPerDay = (function(){
    let thisChart = null;
    let chartFirstDate = null;

    function createChartData(data, options, selected) {
        const datasets = [{ // Guide for LineWithLine
            label: '',
            id: 'hidden-guide',
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0)',
            data: [],
            type: 'LineWithLine',
            selected: true,
            order: 0,
            pointRadius: 0
        }];

        const dataOrder = {
            '00-10': 1,
            '10-20': 2,
            '20-30': 3,
            '30-40': 4,
            '40-50': 5,
            '50-60': 6,
            '60-70': 7,
            '70-80': 8,
            '80': 9
        };

        const ageIdxMap = {};

        for (let day of data.agesPerDay) {
            if (day.count > 0) {
                const newDate = moment(day.date);
                newDate.set({
                    hour: 0,
                    minute: 0,
                    second: 0
                });

                if (newDate >= chartFirstDate) {
                    datasets[0].data.push({
                        x: newDate,
                        y: 0
                    });

                    for (const age of day.ages) {
                        if (typeof ageIdxMap[age.slug] === 'undefined') {
                            ageIdxMap[age.slug] = datasets.length;
                            datasets.push({
                                label: age.name,
                                id: age.slug,
                                backgroundColor: options.chartColors[ageIdxMap[age.slug]],
                                borderColor: options.chartColors[ageIdxMap[age.slug]],
                                barThickness: 'flex',
                                count: age.count,
                                data: [],
                                type: 'bar',
                                selected: selected && Array.isArray(selected) ? selected.indexOf(age.slug) !== -1 : true,
                                order: dataOrder[age.slug],
                                pointRadius: 0
                            });
                        }

                        datasets[ageIdxMap[age.slug]].data.push({
                            x: newDate,
                            y: age.count > 0 ? age.count : 0
                        });

                    }
                }
            }
        }

        return datasets;
    }

    function getChartFirstDay(data) {
        chartFirstDate = window.config.firstDayValues['ages'];

        const dataFirstDate = moment(data.ages[0].days[0].date);
        const formattedAgeChartFirstDay = window.config.firstDayValues['ages'].format('YYYY-MM-DD')
        if (dataFirstDate.format('YYYY-MM-DD') === formattedAgeChartFirstDay) {
            // add one day if this is the same as data first day
            chartFirstDate = moment(formattedAgeChartFirstDay, 'YYYY-MM-DD').add('1','day');
        }

        return chartFirstDate;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartFirstDate = getChartFirstDay(data);

        // Initially selected
        let selectedAges = storage.getData('ages-per-day-chart_multiselect');
        if (!selectedAges || !Array.isArray(selectedAges)) {
            selectedAges = null;
        }

        const datasets = createChartData(data, window.config, selectedAges);

        thisChart = new CovidChart('ages-per-day-chart', {
            datasets,
            chartOptions: {
                type: 'bar',
                options: {
                    tooltips: {
                        intersect: false,
                        mode: 'index',
                        callbacks: {
                            label: function(tooltipItem) {
                                let label = tooltipItem.dataset.label + ': ' || '';
                                label = label + '+'+tooltipItem.formattedValue;

                                return label;
                            }
                        },
                        itemSort: function(a, b, data) {
                            const orderA = data.datasets[a.datasetIndex].order;
                            const orderB = data.datasets[b.datasetIndex].order;

                            return orderA < orderB ? 1 : -1;
                        }
                    },
                    scales: {
                        x: {
                            type: 'timeseries',
                            stacked: true,
                            offset: true,
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M',
                                }
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                precision: 0,
                                min: 0
                            }
                        }
                    }
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'ages-per-day-chart-tooltip'
            },
            multiselect: {
                requireCount: false,
                valueType: 'string',
                idField: 'id',
                colorField: 'backgroundColor',
                inputName: 'ages-per-day-multiselect',
                selectElemId: 'ages-per-day-multiselect',
                colorElemId: 'ages-per-day-multiselect-colors',
                countElemId: 'ages-per-day-multiselect-count',
                selectAllElemId: 'ages-per-day-multiselect-select-all',
                clearAllElemId: 'ages-per-day-multiselect-clear-all'
            },
            responsive: ['aspectRatio']
        });
    }

    function reload(data) {
        // New first date value
        chartFirstDate = getChartFirstDay(data);
        const datasets = createChartData(data, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default agesPerDay;
